<ng-container *ngIf="viewModel$ | async as vm">
  <div class="is-flex " [ngClass]="{'is-loading blured-overlay': isLoading$ | async}"  *ngIf="hasChanged(vm.currentModeEndTime, vm.selectedEndDate, vm.selectedEndTime, vm.errors)">
    <app-icon 
      [class.loading]="(isLoading$ | async)"
      class="validate bg-blue-hover-5 bg-blue-10 text-24 text-blue"
      name="check"
      (click)="validate(vm.selectedEndDate, vm.selectedEndTime)">
    </app-icon>
  </div>
</ng-container>
